React = require('react')
GenericContent = require('../modules/generic-content')

module.exports = React.createClass
    render: ->
        return (
            React.createElement("div", {"className": "aboutme"},
                React.createElement(GenericContent, {"title": "About x32"}, """
                    In """, React.createElement("a", {"href": "https://sites.google.com/site/x32abi/"}, "short"), """: A 32-bit psABI for x86-64 with 32-bit pointer size.
""", React.createElement("br", null), React.createElement("br", null), """
                    Under x32, there will be new binary libraries for everything, from glibc to your compiled application.
                    By design, x32 applications are supposed to run as fast - if not faster - as native x86-64 applications,
                    but consumes less memory. Therefore virtual machines in the cloud with very expensive memory are ideal for x32.
"""),

                React.createElement(GenericContent, {"title": "ArchLinux x32"}, """
                    I am maintaining some common ArchLinux x32 libraries. Thanks to the community of Debian, Gentoo and more, my packages
                    so far compile well. They are available on """, React.createElement("a", {"href": "https://aur.archlinux.org/packages/?SeB=m&K=fantix"}, "AUR"), """,
                    and """, React.createElement("a", {"href": "https://wiki.archlinux.org/index.php/Unofficial_user_repositories#archlinuxcn"}, "ArchLinux CN"), """ as
                    pre-compiled packages. Other than AUR, the sources can also be found at """, React.createElement("a", {"href": "https://github.com/archlinux-x32"}, """
                    GitHub"""), """.
""", React.createElement("br", null), React.createElement("br", null), """
                    To get your hands dirty, you\'ll need 64-bit ArchLinux and a kernel that enables """, React.createElement("code", null, "CONFIG_X86_X32"), """,
                    for example """, React.createElement("a", {"href": "https://aur.archlinux.org/packages/linux-pf/"}, "linux-pf"), """. Then the easier way is to
                    install the """, React.createElement("code", null, "libx32-*"), """ packages from ArchLinux CN repository mentioned above, or you\'ll need to compile
                    the world from seeds - I\'ll explain that part in separate page.
"""),

                React.createElement(GenericContent, {"title": "Contribute"}, """
                    This project is open for maintainers - please feel free to """, React.createElement("a", {"href": "mailto:i@fantix.pro"}, "leave me a message"), """ if
                    you want to help.
""")
            )
        )   



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/pages/aboutme.cjsx
 **/